import styles from "./desktop-pricing-features-table.module.scss";
import {
  PricingFeatureBase,
  PricingFeaturesTableProps,
} from "@/components/pages/pricing-a/components/pricing-features/pricing-features.data";

const DesktopPricingFeaturesTable = <T extends PricingFeatureBase>({
  title,
  featuresData,
  featureMap,
}: PricingFeaturesTableProps<T>) => {
  const featureKeys = Object.keys(featuresData[0]).filter(
    (key) => key !== "name",
  );
  return (
    <div className={styles.table_wrapper}>
      {/* Header columns */}
      <div className={styles.features_titles}>
        <div className={styles.header}>{title}</div>
        {Object.keys(featureMap).map((feature) => (
          <div key={feature} className={styles.feature_name}>
            {feature}
          </div>
        ))}
      </div>
      {/* Feature Rows */}
      <div className={styles.features_list}>
        {/* Header Row */}
        <div className={styles.features_rows_header}>
          {featuresData.map((plan) => (
            <div key={plan.name} className={styles.header}>
              {plan.name}
            </div>
          ))}
        </div>

        {/* Feature Rows */}
        {featureKeys.map((key, indexKey) => {
          const isLastRow = indexKey === featureKeys.length - 1;

          return (
            <div key={key} className={styles.features_rows}>
              {featuresData.map((plan, index) => {
                const isLastItemInRow = index === featuresData.length - 1;
                const shouldAddCorner = isLastItemInRow && isLastRow;

                return (
                  <div
                    key={plan.name + key}
                    className={`${styles.content_data} ${shouldAddCorner ? styles.bordered_corner : ""}`}
                  >
                    {plan[key]}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DesktopPricingFeaturesTable;
